import React from 'react';

export const ProfileInfo = () => {
    return (
        <div>
            ProfileInfo
        </div>
    )
}